import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreLegacyModule } from '@isophi/core-legacy';
import { CarouselModule } from "ngx-owl-carousel-o";

import { SharedModule } from '../../shared/shared.module';
import { ArchiveNotificationComponent } from './components/archive-notification/archive-notification.component';
import { DiagnosticVideoComponent } from './components/diagnostic-video/diagnostic-video.component';
import { MaterialComponent } from './components/material/material.component';
import { MaterialSetComponent } from './components/material-set/material-set.component';
import { MaterialSingleComponent } from './components/material-single/material-single.component';
import { ProductCardComponent } from './components/product-card/product-card.component';
import { PromoProductComponent } from './components/promo-product/promo-product.component';
import { ReportPreviewComponent } from './components/report-preview/report-preview.component';
import { VideoTutorialsComponent } from './components/video-tutorials/video-tutorials.component';
import { VisualNavigationComponent } from './components/visual-navigation/visual-navigation.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { IndexComponent } from './pages/index/index.component';
import { ManualsComponent } from './pages/manuals/manuals.component';
import { MaterialsComponent } from './pages/materials/materials.component';

@NgModule({
  imports: [CoreLegacyModule, CommonModule, SharedModule, DashboardRoutingModule, CarouselModule],
  declarations: [
    IndexComponent,
    MaterialSetComponent,
    MaterialSingleComponent,
    ArchiveNotificationComponent,
    VideoTutorialsComponent,
    VisualNavigationComponent,
    ReportPreviewComponent,
    MaterialsComponent,
    ManualsComponent,
    PromoProductComponent,
    ProductCardComponent,
    MaterialComponent,
    DiagnosticVideoComponent,
  ],
  exports: [DiagnosticVideoComponent],
})
export class DashboardModule {}
